import { I18nType } from '@/ui/types/i18n.types';
import { Rules } from '@/ui/types/rules.types';
import requiredRule from './rules/required.rule';
import maxLengthRule from './rules/max-length.rule';
import emailRule from './rules/email.rule';
import exactRule from './rules/exact.rule';
import passwordRule from './rules/password.rule';
import usernameRule from './rules/username.rule';
import fileSizeRule from './rules/file-size.rule';

const ruleFunctions = (i18n: I18nType) => ({
  required: requiredRule(i18n),
  maxLength: maxLengthRule(i18n),
  email: emailRule(i18n),
  exact: exactRule(i18n),
  password: passwordRule(i18n),
  username: usernameRule(i18n),
  fileSize: fileSizeRule(i18n),
});

export default function (i18n: I18nType): Rules {
  const {
    required,
    maxLength,
    email,
    exact,
    password,
    username,
    fileSize,
  } = ruleFunctions(i18n);

  return {
    required,
    maxLength,
    email,
    exact,
    password,
    username,
    fileSize,
  };
}
